import { ClientCollection } from "..";
class AbstractPostCollection extends ClientCollection {}
export { AbstractPostCollection };